var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRequestPending)?_c('section'):(_vm.isRequestFailed)?_c('section',[_vm._v(" Failed to load collection ")]):(_vm.collection && _vm.collection.length)?_c('yn-with-title',{staticClass:"topics container",attrs:{"title":"Topics"}},[_c('yn-list',{attrs:{"name":"topics","data":_vm.collection,"total":_vm.total,"metadata":{
      title: {
        label: 'Title',
        width: '200px'
      },
      description: {
        label: 'Description',
        width: 'minmax(0, 1fr)'
      },
      createdAt: {
        label: 'Created At',
        width: '175px'
      },
      createdBy: {
        label: 'Created By',
        width: '200px'
      }
    },"actions":[{ name: 'delete', label: '&times;', tooltip: 'Delete this item' }],"is-request-pending":_vm.isRequestPending,"is-request-failed":_vm.isRequestFailed},on:{"delete":_vm.remove},scopedSlots:_vm._u([{key:"gal",fn:function(){return [(!_vm.isRequestPending)?_c('router-link',{attrs:{"to":"/topics/create"}},[_vm._v("+ new topic")]):_vm._e()]},proxy:true},{key:"title",fn:function(ref){
    var value = ref.value;
    var item = ref.item;
return [_c('router-link',{attrs:{"to":{ path: ("/topics/" + (item.id)) }}},[_vm._v(_vm._s(value))])]}},{key:"createdAt",fn:function(ref){
    var value = ref.value;
return [_vm._v(" "+_vm._s(new Date(value).toLocaleString())+" ")]}}])})],1):_c('yn-sample')}
var staticRenderFns = []

export { render, staticRenderFns }